module.exports = __webpack_public_path__ + "static/img/6.e3ef12a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shangji/6.png
// module id = 5YZ+
// module chunks = 1